import Script from 'next/script';
import { checkLogin } from 'portal-common-account/src/api/login';
import { addParamsToUrl } from 'portal-common-account/src/utils/url';
import React, { Fragment } from 'react';

export function OneClickLogin() {
  const init = async () => {
    if (window.google) {
      const parentId = getParentId();
      let isLogin = false;
      try {
        await checkLogin();
        isLogin = true;
      } catch (err) {}
      
      if (!isLogin) {
        window.google.accounts.id.initialize({
          client_id: '197198799412-9m5mt0khbiuofvs910s3972h4no0ih0h.apps.googleusercontent.com',
          callback: handleCredentialResponse,
          cancel_on_tap_outside: false,
          login_uri: 'https://intl.cloud.tencent.com/account/oauth/google/authCallback',
          prompt_parent_id: parentId,
          itp_support: true,
        });
        window.google.accounts.id.prompt((notification) => {
          if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            // document.cookie = 'g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
            window.google.accounts.id.prompt();
          }
        });
      }
    }
  };

  const getParentId = () => {
    const globalHeader = document.getElementById('navigationBar');
    if (globalHeader) {
      globalHeader.style = 'position:relative;';
      const container = document.createElement('div');
      container.id = 'google-oneClick';
      container.style = 'position:absolute;right:24px;top:100%';
      globalHeader.appendChild(container);
      return 'google-oneClick';
    }
    return '';
  };

  const handleCredentialResponse = async (res) => {
    location.href = addParamsToUrl('/account/oauth/google/authCallback', {
      redirectUri: encodeURIComponent(location.href),
      idToken: res.credential,
    });
  };

  return (
    <Fragment>
      <Script src="https://accounts.google.com/gsi/client" onLoad={init} />
    </Fragment>
  );
}
